import { ResponseCode } from '@base/utils/constants';

export default function getMessage(
  code: number,
  messages: Record<number, string>
) {
  const title = code === ResponseCode.SUCCESS ? 'success' : 'Error';
  let message = 'unknown_error_try_again';

  const msg = messages[code];
  if (msg) message = msg;

  return { title, message };
}
